import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Rating from '@mui/material/Rating'
import AI from '../Image/AI.jpg'
import ML from '../Image/ML.jpg'
import WD from '../Image/WD.webp'
import DS from '../Image/DS.jpeg'
import { BsArrowUpRight } from 'react-icons/bs'

function Popular_cource() {
  const courses = [
    {
      title: 'Artificial Intelligence',
      description:
        'Get started on an exciting new adventure in AI with our all-encompassing training program. This course will...',
      imageUrl: AI,
      rating: 4,
      link: '/Artificial-Intelligence',
      alt: 'Artificial-Intelligence',
    },
    {
      title: 'Machine Learning',
      description:
        'With our course, take a thorough exploration of the field of machine learning. Explore both supervised and...',
      imageUrl: ML,
      rating: 4,
      link: '/Machine-Learning',
      alt: 'Machine-Learning',
    },
    {
      title: 'Web Development',
      description:
        'With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM manipulation, jQuery, Node.js, and...',
      imageUrl: WD,
      rating: 4,
      link: '/Web-Development',
      alt: 'Web-Development',
    },
    {
      title: 'Data Science',
      description:
        'In this course on data science, you will take a deep dive into data collection methods, learn the fundamentals of...',
      imageUrl: DS,
      rating: 4,
      link: '/Data-Science',
      alt: 'Data-Science',
    },
  ]
  return (
    <div>
      <div className="container-fluid Popular_cource_text px-5 mt-4">
        <h1> Our Trending Program</h1>
        <p className="pt-2">
        "Join our renowned Programs; the knowledge provided will surely be invaluable to you!"
        </p>
      </div>
      {/* ---------------------------Desktop View----------------------- */}
      <div className="d-none d-xl-block">
        <div className="container">
          <div className="row">
            {courses.map((course, index) => (
              <div className="col-md-3" key={index}>
                <Link className="Program_card_link" to={course.link}>
                  <div className="border shadow-sm Program_card pb-1">
                    <div className="p-3">
                      <img
                        className="border rounded"
                        src={course.imageUrl}
                        alt={course.title}
                      />
                    </div>
                    <div className="px-3">
                      <div className="row">
                        <div className="col-md-10">
                          <h1 className="pt-2">{course.title}</h1>
                        </div>
                        <div className="col-md-2">
                          <BsArrowUpRight className="text-end" />
                        </div>
                        <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                        <b>Duration:</b> 2 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                        4.5{' '}
                        <Rating
                          name="half-rating-read"
                          size="small"
                          defaultValue={5}
                          precision={4}
                          readOnly
                        />
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ------------------Tab View-------------------- */}
      <div className="container d-none d-md-block d-xl-none">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-md-3" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border shadow tab_Program_card pb-1">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3 tab_Program_card">
                    <div className="row">
                      <div className="col-md-10">
                        <h1 className="">{course.title}</h1>
                      </div>
                      <div className="col-md-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* ------------------mobile View-------------------- */}
      <div className="container d-sm-block d-md-none">
        <div className="row">
          {courses.map((course, index) => (
            <div className="col-12 px-4" key={index}>
              <Link className="Program_card_link" to={course.link}>
                <div className="border pb-2 shadow Program_mobile_card">
                  <div>
                    <img
                      className="p-2"
                      src={course.imageUrl}
                      alt={course.title}
                    />
                  </div>
                  <div className="px-3">
                    <div className="row">
                      <div className="col-10">
                        <h1 className="pt-2">{course.title}</h1>
                      </div>
                      <div className="col-2">
                        <BsArrowUpRight className="text-end" />
                      </div>
                      <p className="pt-1">{course.description}</p>
                      </div>
                      <h6>
                      <b>Duration:</b> 2 Months
                      </h6>
                      <h5 className="fw-normal pt-2">
                      4.5{' '}
                      <Rating
                        name="half-rating-read"
                        size="small"
                        defaultValue={5}
                        precision={4}
                        readOnly
                      />
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="text-center mt-4">
        <button className="shadow-sm px-4 py-1 Popular_cource_button">
          Explore More
        </button>
      </div> */}
    </div>
  )
}

export default Popular_cource
